import { useState } from 'react';

export default function AdminServices() {
  const [services] = useState([]);

  return (
    <div className="container-fluid mt-4">
      <div className="row mb-4">
        <div className="col-md-8">
          <h2>Manage Services</h2>
        </div>
        <div className="col-md-4 text-end">
          <button className="btn btn-primary">Add Service</button>
        </div>
      </div>

      <div className="alert alert-info">
        <strong>Services Management</strong> - Coming Soon
      </div>

      {services.length === 0 && (
        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th>Category</th>
                <th>Price</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  No services yet. Click "Add Service" to create one.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
